import React, { useState } from 'react'
import { Avatar, Col, DatePicker, Form, Input, Row, Select } from 'antd'
import CustomModal from 'components/global/CustomModal'
import { eventAttendanceStore } from 'state/event/eventAttendance'
import FileUploader from 'helper/FileUploader'
import userAvatarSvg from 'assets/Images/userAvatar.svg'
import { validateAlphabets } from 'helper/utility'
import GenderSelect from 'helper/GenderSelect'
import GradeInput from 'pages/Family/Profiles/FamilyProfile/FamilyMembers/Modals/Kid/ModalContent/GradeInput'
import CustomModalFooter from 'components/global/CustomModalFooter'
import useFormSubmit from 'helper/Hooks/formSubmit'
import moment from 'moment'
import {
  useCreateDropInAttendee,
  useEditDropInAttendee,
} from 'api/Event/Dropin'
import { myStore } from 'state/store'
import { useParams } from 'react-router-dom'
import { CreateDropInAttendeePayload } from 'types/event/dropInAttendees'

const AddDropIn: React.FC = () => {
  const { id }: { id: string } = useParams()
  const { form, handleSubmit } = useFormSubmit()
  const {
    addDropInAttendeeModalOpen,
    dropInAttendeeData,
    setDropInAttendeeData,
    setAddDropInAttendeeModalOpen,
    setCheckInOutModalOpen,
    participantData,
    setParticipantData,
  } = eventAttendanceStore(store => ({
    addDropInAttendeeModalOpen: store.addDropInAttendeeModalOpen,
    dropInAttendeeData: store.dropInAttendeeData,
    setDropInAttendeeData: store.setDropInAttendeeData,
    setAddDropInAttendeeModalOpen: store.setAddDropInAttendeeModalOpen,
    setCheckInOutModalOpen: store.setCheckInOutModalOpen,
    participantData: store.participantData,
    setParticipantData: store.setParticipantData,
  }))
  const setModalBtnLoader = myStore(store => store.setModalBtnLoader)
  const [avatar, setAvatar] = useState()
  const [attnedeeType, setAttnedeeType] = useState<
    'kid' | 'guardian' | 'authorizedAdult'
  >(dropInAttendeeData ? dropInAttendeeData.type : 'kid')
  const { mutate: createDropInAttendeeMutation } = useCreateDropInAttendee()
  const { mutate: editDropInAttendeeMutation } = useEditDropInAttendee()

  const formSchema = {
    photoId: dropInAttendeeData ? dropInAttendeeData.photoId : undefined,
    firstName: dropInAttendeeData ? dropInAttendeeData.firstName : undefined,
    lastName: dropInAttendeeData ? dropInAttendeeData.lastName : undefined,
    gender: dropInAttendeeData ? dropInAttendeeData.gender : undefined,
    gradeId: dropInAttendeeData ? dropInAttendeeData.gradeId : undefined,
    dob: dropInAttendeeData ? moment(dropInAttendeeData.dob) : undefined,
  }

  const closeModal = () => {
    setAddDropInAttendeeModalOpen(false)
    if (!dropInAttendeeData) {
      setCheckInOutModalOpen(true)
    }
  }

  const onFinish = (values: CreateDropInAttendeePayload) => {
    const paylaod = {
      ...values,
      dob: values.dob ? moment(values.dob).format('YYYY-MM-DD') : undefined,
      eventId: id,
      type:
        attnedeeType === 'authorizedAdult' ? 'authorized-adult' : attnedeeType,
    }

    setModalBtnLoader(true)

    if (dropInAttendeeData) {
      editDropInAttendeeMutation(
        {
          attendeeId: dropInAttendeeData._id,
          payload: paylaod as CreateDropInAttendeePayload,
        },
        {
          onSuccess: data => {
            setParticipantData({
              ...participantData,
              dob: data.dob,
              firstName: data.firstName,
              lastName: data.lastName,
              gender: data.gender,
              photoId: data.photoId,
              photo: data.photo,
              type: data.type,
              gradeId: data.gradeId,
              grade: data.grade,
              status: data.status,
            })
            setDropInAttendeeData({
              ...dropInAttendeeData,
              dob: data.dob,
              firstName: data.firstName,
              lastName: data.lastName,
              gender: data.gender,
              photoId: data.photoId,
              photo: data.photo,
              type: data.type,
              gradeId: data.gradeId,
              grade: data.grade,
              status: data.status,
            })
            setModalBtnLoader(false)
            setAddDropInAttendeeModalOpen(false)
          },
          onError: () => {
            setModalBtnLoader(false)
          },
        },
      )
    } else {
      createDropInAttendeeMutation(paylaod as CreateDropInAttendeePayload, {
        onSuccess: () => {
          setModalBtnLoader(false)
          closeModal()
        },
        onError: () => {
          setModalBtnLoader(false)
        },
      })
    }
  }

  const attendeTypes = [
    {
      key: 'authorizedAdult',
      name: 'Authorized Adult',
    },
    {
      key: 'kid',
      name: 'Kid',
    },
    {
      key: 'guardian',
      name: 'Guardian',
    },
  ]

  console.log(participantData, 'data....')

  return (
    <>
      <CustomModal
        openModal={addDropInAttendeeModalOpen}
        isCloseModalCustom
        closeModal={closeModal}
        title={
          dropInAttendeeData ? 'Edit drop-in attendee' : 'Add drop-in attendee'
        }
        width={600}
        footer={
          <CustomModalFooter
            multibutton={false}
            btnAlignment="justify-end"
            btnText={dropInAttendeeData ? 'Save' : 'Check-in'}
            btnType="primary"
            onSubmit={handleSubmit}
          />
        }
      >
        <div>
          <Form initialValues={formSchema} form={form} onFinish={onFinish}>
            <Row gutter={24} align="middle">
              <Col span={4} className="mb-10px">
                <Avatar
                  size={80}
                  src={avatar ? avatar : userAvatarSvg}
                ></Avatar>
              </Col>
              <Col span={18} className="">
                <Form.Item name="photoId">
                  <FileUploader
                    setAvatar={setAvatar}
                    name="drop-in"
                    form={form}
                    text={'Upload a photo'}
                    fileId={
                      dropInAttendeeData
                        ? dropInAttendeeData.photoId
                        : undefined
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            <Row gutter={24} className="mt-10px">
              <Col span={12}>
                <label className="input-label required-input">First Name</label>
                <Form.Item
                  colon={false}
                  name="firstName"
                  rules={[
                    { required: true, message: 'First Name required' },
                    { validator: validateAlphabets },
                  ]}
                >
                  <Input
                    placeholder="Enter First Name"
                    required
                    name="firstname"
                  />
                </Form.Item>
              </Col>
              <Col span={12}>
                <label className="input-label required-input">Last Name</label>
                <Form.Item
                  colon={false}
                  name="lastName"
                  rules={[
                    { required: true, message: 'First Name required' },
                    { validator: validateAlphabets },
                  ]}
                >
                  <Input placeholder="Enter Middle Name" name="lastName" />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24} className="">
                <label className="input-label required-input">Gender</label>
                <Form.Item
                  name="gender"
                  rules={[{ required: true, message: 'Gender is required' }]}
                >
                  <GenderSelect
                    form={form}
                    data={
                      dropInAttendeeData ? dropInAttendeeData.gender : undefined
                    }
                  />
                </Form.Item>
              </Col>
            </Row>

            {attnedeeType === 'kid' && (
              <Row>
                <Col span={24}>
                  <label htmlFor="" className="input-label">
                    Grade
                  </label>
                  <Form.Item name="gradeId" colon={false}>
                    <GradeInput
                      form={form}
                      gradeId={''}
                      data={
                        dropInAttendeeData
                          ? dropInAttendeeData.gradeId
                          : undefined
                      }
                    />
                  </Form.Item>
                </Col>
              </Row>
            )}

            <Row>
              <Col span={24}>
                <label className="input-label required-input">
                  Date of Birth
                </label>
                <Form.Item
                  name="dob"
                  rules={[
                    { required: true, message: 'Date of birth required' },
                  ]}
                >
                  <DatePicker name="dob" className="selector w-full" />
                </Form.Item>
              </Col>
            </Row>

            <Row>
              <Col span={24} className="">
                <label className="input-label">Attendee type</label>
                <Form.Item name="type">
                  <Select
                    className="h-50px select-field"
                    placeholder={'Select'}
                    defaultValue={attnedeeType}
                    onChange={(v, item: any) => {
                      setAttnedeeType(item.key)
                      form.setFieldsValue({
                        type: item.key,
                      })
                    }}
                  >
                    {attendeTypes.map(
                      (attendee: { key: string; name: string }) => (
                        <Select.Option key={attendee.key} value={attendee.name}>
                          {attendee.name}
                        </Select.Option>
                      ),
                    )}
                  </Select>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </div>
      </CustomModal>
    </>
  )
}

export default AddDropIn
